var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('rect',{attrs:{"xmlns":"http://www.w3.org/2000/svg","y":"4","width":"16","height":"4","fill":"#F5F8FB"}}),_c('rect',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"5","fill":"#A71B14"}}),_c('rect',{attrs:{"xmlns":"http://www.w3.org/2000/svg","y":"7","width":"16","height":"5","fill":"#A71B14"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }